import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { HOLDINGS_ICON_URL } from '../../../../utils/map/layers';

import s from './HybridActivityMap.module.scss';

/**
 * A layer as its points are drawn: a white disc with the layer's colour on the
 * border and the glyph.
 *
 * The same mark serves the picker and the map, so what a reader ticks and what
 * they read the map by are the one thing. The holdings layer is marked the
 * way its markers are already drawn everywhere else — the shared map's white
 * disc and glyph — rather than dressed up as another incident layer.
 */
const HybridActivityLayerSwatch = ({ layer }) => {
    if (layer.isHoldings) {
        return (
            <span className={classNames(s.Swatch, s['Swatch--Holdings'])}>
                <img src={HOLDINGS_ICON_URL} alt="" className={s.SwatchIcon} />
            </span>
        );
    }

    return (
        <span className={s.Swatch} style={{ borderColor: layer.colour }}>
            {/* Decorative: the layer's name sits beside it in both places it
                is used. The glyph is CSS content rather than child text, so
                the symbol's name never reads as part of that name — here or
                in the picker's labels. */}
            {layer.icon && (
                <span
                    aria-hidden="true"
                    className={s.SwatchGlyph}
                    data-icon={layer.icon}
                    style={{ color: layer.colour }}
                />
            )}
        </span>
    );
};

HybridActivityLayerSwatch.propTypes = {
    layer: PropTypes.shape({
        icon: PropTypes.string,
        colour: PropTypes.string,
        isHoldings: PropTypes.bool,
    }).isRequired,
};

export default HybridActivityLayerSwatch;
